import type { DelayTime } from '@/constants';
import type { Asset, ISingleItem } from '@/interfaces';

export enum PmtOnboardingPopupTrigger {
  AfterFirstParcelLoads = 'After first parcel loads',
  UserScrollsToTheBottomOfThePage = 'User scrolls to the bottom of the page',
}

export enum PmtOnboardingPopupVariant {
  TwoPanelCenter = '2-panel center',
  SimpleCenter = 'Simple center',
  Corner = 'Corner',
}

export interface ITrackingLeftPanel {
  joinUsHeader?: string;
  joinUsValuePropositionList?: Array<ISingleItem>;
}
export interface ITrackingRightPanel {
  joinUsDesktopMainText?: string;
  joinUsSubtext?: string;
  desktopGoogleCta?: string;
  subPmcNewsletterText?: string;
  newsletterSubText?: string;
  heroImage?: Asset;
  sys?: { id: string };
  zapierHookId?: string;
  newUserTriggerTimes?: Array<number> | null;
  returnUserTriggerTimes?: Array<number> | null;
  trigger?: PmtOnboardingPopupTrigger;
  variant?: PmtOnboardingPopupVariant;
  loginByEmail?: boolean;
  identifier?: string;
  onNext?: () => void;
  onClose?: () => void;

  // For GTM
  delayTime?: DelayTime;
}

export type IPmtOnboardingPopup = ITrackingLeftPanel & ITrackingRightPanel;

export enum PmtSignUpStep {
  SignUp = 'Sign Up',
  VerifyEmail = 'Verify Email',
  Success = 'Success',
}

export enum PmtOnboardingPopupCta {
  Noti = 'noti',
  Login = 'login',
  DelayedShipment = 'delayed shipment',
  ShipmentSummary = 'shipment summary',
}
